export const BOOTCAMP_LIST_SUCCESS = "BOOTCAMP_LIST_SUCCESS";
export const BOOTCAMP_LIST_FAILURE = "BOOTCAMP_LIST_FAILURE";

export const BOOTCAMP_SINGLE_SUCCESS = "BOOTCAMP_SINGLE_SUCCESS";
export const BOOTCAMP_SINGLE_FAILURE = "BOOTCAMP_SINGLE_FAILURE";

export const BOOTCAMP_MANUAL_SUCCESS = "BOOTCAMP_MANUAL_SUCCESS";
export const BOOTCAMP_MANUAL_FAILURE = "BOOTCAMP_MANUAL_FAILURE";
